import {
	currentUserMeetsUserLevel,
	getPreference,
} from '@netx/core-user-next/utils';
import {isMobile} from '@netx/core-next/utils/browser';
import {
	ProjectReviewPref,
	PROJECT_REVIEWS_VIEW_MINIM_USER_LEVEL,
} from './constants';

export const canViewProjectReviews = () =>
	!isMobile() &&
	currentUserMeetsUserLevel(PROJECT_REVIEWS_VIEW_MINIM_USER_LEVEL);

export const projectReviewEnabled = () =>
	getPreference(ProjectReviewPref.ENABLED, true);
